import { useQuery } from "@apollo/client";
import ME from "../../gql/common/me.query";
import useWindowVisible from "../useWindowVisible";
import { useEffect } from "react";

const useUser = (params = {}) => {
  const isWindowFocused = useWindowVisible();
  const { refetch, ...result} = useQuery(ME, params);

  useEffect(() => {
    if (isWindowFocused && params.refetchOnWindowVisible) {
      console.log("useUser: refetching user data on window focus");
      refetch();
    }
  }, [isWindowFocused, refetch, params.refetchOnWindowVisible]);

  return {
    ...result,
    refetch,
    user: result.data?.me,
  };
}

export default useUser;